import { VueConstructor } from 'vue'
import VueCurrencyFilter from 'vue-currency-filter'
import VueGeolocation from 'vue-browser-geolocation'
import VueTheMask from 'vue-the-mask'
import WebCam from 'vue-web-cam'

export function installVue2InputPlugins(Vue: VueConstructor) {
    Vue.use(VueTheMask)
    Vue.use(WebCam)
    Vue.use(VueCurrencyFilter, {
        symbol: 'R$',
        thousandsSeparator: '.',
        fractionCount: 2,
        fractionSeparator: ',',
        symbolPosition: 'front',
        symbolSpacing: true
    })
    Vue.use(VueGeolocation)
}
